import React, { useState } from "react";
import Lottie from "lottie-react";
import bannerAnimation from "../../../../assets/animation/Banner.json";
import "./Banner.scss";
import {
  PlayIcon,
  AppStore,
} from "../../../../assets/StoreAsset/StoreAssets";
import { ButtonCustom } from "../../../../Common/ButtonCustom/ButtonCustom";

function Banner() {
  return (
    <div className="bannerSection" id="home">
      <div className="bannerSection_contant container">
        <div className="bannerSection_left">
          <h1>
            <span> Seamlessly </span><span> Integrated </span>
            Securely Managed
          </h1>
          <p>
            One platform to manage and integrate all financial assets —fiat and crypto
          </p>
          <div className="bannerSection_left_button">
            <ButtonCustom
              label="Play Store"
              leftIcon={<PlayIcon />}
            />
            <ButtonCustom
              label="App Store"
              customClass='btnBorder'
              leftIcon={<AppStore />
              }
            />
          </div>
        </div>
        <div className="bannerSection_right">
          <Lottie animationData={bannerAnimation} loop={true} />
        </div>
      </div>
    </div>
  );
}

export default Banner;
